import { gql } from '@apollo/client';

import { academyRoleFragment } from '../fragments';
import { AcademyRole } from '../../types';

export interface GetAcademyRolesQueryResult {
  roles: AcademyRole[];
}

export const getAcademyRolesQuery = gql`
  query GetAcademyRolesQuery {
    roles @rest(type: "AcademyRole", path: "academy/roles") {
      ...AcademyRole
    }
  }
  ${academyRoleFragment}
`;
